import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { OutputAnalyticsReportFilterDialogComponent } from './output-analytics-report-filter-dialog.component';

@NgModule({
  imports: [
    McColorModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatInputModule,
    MatToolbarModule
  ],
  declarations: [
    OutputAnalyticsReportFilterDialogComponent
  ],
  exports: [
    OutputAnalyticsReportFilterDialogComponent
  ]
})
export class OutputAnalyticsReportFilterDialogModule { }
